import { Deserializable } from '../protocols/deserializable';
import { MemberRetirementTypeIdEnum } from './enum/member-retirement-type-id.enum';
import { RetirementType } from './retirement-type';

export class MemberRetirementType implements Deserializable {
  public retirementTypeId!: MemberRetirementTypeIdEnum;
  public retirementType!: RetirementType;

  public onDeserialize(): void {
    if (this.retirementType) {
      this.retirementType = window?.injector?.Deserialize?.instanceOf(RetirementType, this.retirementType);
    }
  }
}
